export const fetchDirectories = resp => {
  return {
    type: "FETCH_DIRECTORIES",
    payload: resp
  };
};

export const fetchInfiniteDirectories = resp => {
  return {
    type: "FETCH_INFINITE_DIRECTORIES",
    payload: resp
  };
};

export const setDirectorySelectedOrg = org => {
  return {
    type: "SET_DIRECTORY_SELECTED_ORG",
    org
  };
};

export const resetDirectorySelectedOrg = () => {
  return {
    type: "RESET_DIRECTORY_SELECTED_ORG"
  };
};

export const saveDirectoryStateToCache = () => ({
  type: "SAVE_DIRECTORY_STATE_TO_CACHE"
});

export const restoreDirectoryStateFromCache = () => ({
  type: "RESTORE_DIRECTORY_STATE_FROM_CACHE"
});



// WEBPACK FOOTER //
// ./src/actions/actions/directory.js